import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

/**
 * useAuth Hook - Access authentication state and methods
 *
 * Usage:
 *   const { user, token, role, isAuthenticated, isLoading, logout, updateUserData } = useAuth();
 *
 * Returns:
 * - user: Complete user object from login response
 * - token: JWT authentication token
 * - role: Current user's role (shortcut for user?.role)
 * - isAuthenticated: Boolean flag indicating if user is logged in
 * - isLoading: Boolean flag indicating if auth context is initializing
 * - logout(): Async function to clear auth state and sessionStorage
 * - updateUserData(updatedData): Function to update user info in context and storage
 *
 * Throws:
 * - Error if used outside of AuthProvider
 */
export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
};
